// Core
import React, { useState } from "react";

// Components - Contrib Libraries
import { Button, Form, InputGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Searchbar(props) {
	const { subjectAreaID, subjectAreaName } = props;
	const [searchQuery, setSearchQuery] = useState();
	let navigate = useNavigate();

	var composeSearchQuery = (e) => {
		setSearchQuery(e.target.value);
	};

	var initSearch = function (e) {
		console.log(subjectAreaID);
		e.preventDefault();
		navigate("/search/" + subjectAreaID + "/" + searchQuery);
	};

	return (
		<Form id="searchForm" className="my-3" onSubmit={initSearch}>
			<InputGroup className="mb-3">
				<Form.Control placeholder={"Search in " + subjectAreaName} aria-label={subjectAreaName} onChange={composeSearchQuery} />
				<Button variant="outline-primary" type="submit">
					Search
				</Button>
			</InputGroup>
		</Form>
	);
}

export default Searchbar;
